import ContactsSection from "../components/ContactsSection";

function Contacts({ onContactSubmit }) {
  return <ContactsSection onContactSubmit={onContactSubmit} />;
}

export default Contacts;
